<template>
  <BlockHero v-if="hero" v-editable="hero" :blok="hero" />

  <HubNavigationDesktop
    v-if="blok.navigationMenu?.length"
    :menu="blok.navigationMenu"
  />

  <StoryblokComponent
    v-for="component in blok.content"
    :key="component._uid"
    v-editable="blok"
    :blok="component"
  />
</template>

<script lang="ts" setup>
import type { ContentTypeHubStoryblok } from '@/types/storyblok'

const props = defineProps<{
  blok: ContentTypeHubStoryblok
}>()
const hero = computed(() => props.blok.hero?.[0])
</script>
